/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      const copyButton = document.querySelector( '.social-share__link.share-link' );

      copyButton?.addEventListener( 'click', () => {
        /* Please ensure you are on https for this to work */
        navigator.clipboard.writeText( copyButton.dataset.url )
            .then( () => {
              const copied = copyButton.parentElement.querySelector( '.copied-text' );

              copied.classList.add( 'is-copied' );

              setTimeout( function() {
                copied.classList.remove( 'is-copied' );
              }, 2000 );
            } )
            .catch( () => {
              console.log( 'Failed to copy text.' );
            } );
      } );

      const filters = {
        category: null,
        audience: null,
        content_type: [],
      };
      const blogSidebar = document.querySelector( '.blog__sidebar-inner[data-blog-index-url]' );
      const blogIndexUrl = blogSidebar?.dataset.blogIndexUrl || window.location.pathname;

      const categorySelect = document.querySelector(
          '[data-filter-control="category"]',
      );

      /**
 * Restore state from current URL params on page load
 */
      const params = new URLSearchParams( window.location.search );

      const ctParam = params.get( 'content_type' );
      if ( ctParam ) {
        filters.content_type = ctParam.split( ',' );
        filters.content_type.forEach( ( slug ) => {
          document
              .querySelector( `[data-filter-control="content_type"][data-term-slug="${slug}"]` )
              ?.classList.add( 'is-active' );
        } );
      }

      const audienceParam = params.get( 'audience' );
      if ( audienceParam ) {
        filters.audience = audienceParam;
        document
            .querySelector( `[data-filter-control="audience"][data-term-slug="${audienceParam}"]` )
            ?.classList.add( 'is-active' );
      }

      const categoryParam = params.get( 'category' );
      if ( categoryParam ) {
        filters.category = categoryParam;
        if ( categorySelect ) categorySelect.value = categoryParam;
      }

      /**
 * Content Type (multi select)
 */
      document.querySelectorAll( '[data-filter-control="content_type"]' )
          .forEach( ( button ) => {
            button.addEventListener( 'click', () => {
              const slug = button.dataset.termSlug;

              button.classList.toggle( 'is-active' );

              if ( filters.content_type.includes( slug ) ) {
                filters.content_type = filters.content_type.filter( ( s ) => s !== slug );
              } else {
                filters.content_type.push( slug );
              }

              updateFilters();
            } );
          } );

      /**
 * Audience (single select)
 */
      document.querySelectorAll( '[data-filter-control="audience"]' )
          .forEach( ( button ) => {
            button.addEventListener( 'click', () => {
              const isActive = button.classList.contains( 'is-active' );

              document.querySelectorAll( '[data-filter-control="audience"]' )
                  .forEach( ( btn ) => btn.classList.remove( 'is-active' ) );

              filters.audience = null;

              if ( !isActive ) {
                button.classList.add( 'is-active' );
                filters.audience = button.dataset.termSlug;
              }

              updateFilters();
            } );
          } );

      /**
 * Category (single select)
 */
      if ( categorySelect ) {
        categorySelect.addEventListener( 'change', () => {
          filters.category = categorySelect.value || null;

          updateFilters();
        } );
      }

      /**
 * Update URL + reload
 */
      function updateFilters() {
        const params = new URLSearchParams();

        if ( filters.category ) {
          params.set( 'category', filters.category );
        }

        if ( filters.audience ) {
          params.set( 'audience', filters.audience );
        }

        if ( filters.content_type.length ) {
          params.set(
              'content_type',
              filters.content_type.join( ',' ),
          );
        }

        const url = new URL( blogIndexUrl, window.location.origin );
        url.search = params.toString();
        window.location.href = url.toString();
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'blog', COMPONENT );
} )( app );
